// PrimarySidebar.tsx
import { Button } from "@blueprintjs/core";
import { useNavigate } from "react-router-dom";

export default function PrimarySidebar() {
  const navigate = useNavigate();
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start", // pin content to top
        alignItems: "center",
        padding: "1rem 0",
        boxSizing: "border-box",
      }}
    >
      {/* Dashboard btn at the very top */}
      <Button
        icon="dashboard"
        minimal
        large
        style={{ width: 40, height: 40 }}
        onClick={() => navigate("/dashboard")}
      />
      {/* Projects button below dashboard */}
      <Button
        icon="briefcase"
        minimal
        large
        style={{ width: 40, height: 40, marginTop: "0.5rem" }}
        onClick={() => navigate("/projects")}
      />
    </div>
  );
}
